/**
 * Function-valued translations that cannot live in JSON.
 * Deep-merged into the JSON translations inside I18nProvider.
 */

export const functionTranslations = {
  de: {
    templateEditor: {
      timeMinutesAgo: (m) => `vor ${m} Min.`,
      timeHoursAgo: (h) => `vor ${h} Std.`,
      timeDaysAgo: (d) => `vor ${d} T.`,
      layerPanel: {
        indexBadge: (index) => `T${index}`,
        typeBadge: (type) => {
          if (type === "background") return "BG";
          if (type === "image") return "IMG";
          return "TXT";
        },
      },
      mapping: {
        folderImageCount: (count) => `${count} Bild${count === 1 ? "" : "er"}`,
        pickerTitle: (targetType, targetLabel) => `${targetType} mappen: ${targetLabel}`,
        recordCountLabel: (count) => `${count} ${count === 1 ? "Datensatz" : "Datensätze"}`,
        fieldCountLabel: (count) => `${count} ${count === 1 ? "Feld" : "Felder"}`,
      },
    },
    workspace: {
      page: {
        accessibility: {
          previewDesignAlt: (index) => `Design ${index}`,
          libraryMockupAlt: (name) => `Mockup ${name}`,
        },
        designBatch: {
          added: (addedCount, skippedCount) =>
            skippedCount > 0
              ? `${addedCount} neue Designs hinzugefügt. ${skippedCount} bereits im Stapel vorhandene Duplikate übersprungen.`
              : `${addedCount} Designs zum aktuellen Stapel hinzugefügt.`,
          summary: (count) => `${count} Upload${count === 1 ? "" : "s"}`,
          showing: (visibleCount, totalCount) => `${visibleCount} von ${totalCount} sichtbar`,
          hidden: (hiddenCount) =>
            `${hiddenCount} weiteres Design${hiddenCount === 1 ? "" : "s"} bleibt zunächst eingeklappt.`,
          showMore: (count) => `${count} mehr anzeigen`,
          opacity: (value) => `Design-Deckkraft: ${value}`,
        },
        setupStep: {
          designAreaCount: (count) => `${count} Designbereich${count === 1 ? "" : "e"}`,
        },
        actions: {
          generateDownloaded: (fileName) => `${fileName} wurde heruntergeladen.`,
        },
      },
      legacyGenerator: {
        previewDesignAlt: (index) => `Design ${index}`,
      },
    },
    generation: {
      recentJobsAvailable: (count) => `${count} letzter Job${count === 1 ? "" : "s"} verfügbar.`,
    },
  },
  en: {
    templateEditor: {
      timeMinutesAgo: (m) => `${m}m ago`,
      timeHoursAgo: (h) => `${h}h ago`,
      timeDaysAgo: (d) => `${d}d ago`,
      layerPanel: {
        indexBadge: (index) => `T${index}`,
        typeBadge: (type) => {
          if (type === "background") return "BG";
          if (type === "image") return "IMG";
          return "TXT";
        },
      },
      mapping: {
        folderImageCount: (count) => `${count} image${count === 1 ? "" : "s"}`,
        pickerTitle: (targetType, targetLabel) => `Map ${targetType}: ${targetLabel}`,
        recordCountLabel: (count) => `${count} ${count === 1 ? "record" : "records"}`,
        fieldCountLabel: (count) => `${count} ${count === 1 ? "field" : "fields"}`,
      },
    },
    workspace: {
      page: {
        accessibility: {
          previewDesignAlt: (index) => `Design ${index}`,
          libraryMockupAlt: (name) => `Mockup ${name}`,
        },
        designBatch: {
          added: (addedCount, skippedCount) =>
            skippedCount > 0
              ? `Added ${addedCount} new designs. Skipped ${skippedCount} duplicates already in the batch.`
              : `Added ${addedCount} designs to the current batch.`,
          summary: (count) => `${count} upload${count === 1 ? "" : "s"}`,
          showing: (visibleCount, totalCount) => `Showing ${visibleCount} of ${totalCount}`,
          hidden: (hiddenCount) =>
            `${hiddenCount} more design${hiddenCount === 1 ? "" : "s"} stay collapsed until needed.`,
          showMore: (count) => `Show ${count} more`,
          opacity: (value) => `Design opacity: ${value}`,
        },
        setupStep: {
          designAreaCount: (count) => `${count} design area${count === 1 ? "" : "s"}`,
        },
        actions: {
          generateDownloaded: (fileName) => `Downloaded ${fileName}.`,
        },
      },
      legacyGenerator: {
        previewDesignAlt: (index) => `Design ${index}`,
      },
    },
    generation: {
      recentJobsAvailable: (count) => `${count} recent job${count === 1 ? "" : "s"} available.`,
    },
  },
};
